import { updateObject } from "../../helpers/common/utility";
import * as actionTypes from "../actions/types";

const initialState = {
  detail: null,
  poli: null,
  ttv: null,
  penunjang: {
    laboratorium: null,
    radiologi: null,
    farmasi: null,
  },
};
const setAntrianDetail = (state, action) => {
  return updateObject(state, {
    detail: action.data,
  });
};

const setPoli = (state, action) => {
  return updateObject(state, {
    poli: action.data,
  });
};

const setTTV = (state, action) => {
  return updateObject(state, {
    ttv: action.data,
  });
};

const setPenunjang = (state, action) => {
  return updateObject(state, {
    penunjang: action.data,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ANTRIAN_DETAIL:
      return setAntrianDetail(state, action);
    case actionTypes.SET_ANTRIAN_POLI:
      return setPoli(state, action);
    case actionTypes.SET_ANTRIAN_TTV:
      return setTTV(state, action);
    case actionTypes.SET_ANTRIAN_PENUNJANG:
      return setPenunjang(state, action);

    default:
      return state;
  }
};

export default reducer;
